import {CreateRecommendationRequest, IRecommendationShort, Recommendation} from "../models/recommendation";
import {fetchData} from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";
import {FEEDBACK_ENDPOINTS, RECOMMENDATION_ENDPOINTS} from "./endpoints";
import {ApiResponse} from "../../types/api.types";
import {RecommendationComment} from "../models/recommendation_comment";
import {CreateFeedBackRequest, IFeedback} from "../models/feedback";


export const FeedbackApi = {
    fetchFeedbacksShort: async (): Promise<ApiResponse<IFeedback[]>> => {
        const response = await fetchData(FEEDBACK_ENDPOINTS.FETCH_SHORT, {
            method: "GET",
            headers: {
                Authorization: authToken(),
            },
        }, 2);

        return response.json();
    },
    fetchFeedback: async (feedbackId: string | undefined): Promise<ApiResponse<IFeedback>> => {
        const response = await fetchData(`${FEEDBACK_ENDPOINTS.GET}/${feedbackId}`, {
            method: "GET",
            headers: {
                Authorization: authToken(),
            },
        }, 2);

        return response.json();
    },

    createFeedBack: async (data: CreateFeedBackRequest): Promise<ApiResponse<IFeedback>> => {
        const formData = new FormData();
        formData.append("about", data.about);
        formData.append("contact", data.contact);
        formData.append("text", data.text);
        if (data.files) {
           data.files.forEach((file, index) => {
               formData.append('file_'+index, file);
           })
        }
        const response = await fetchData(FEEDBACK_ENDPOINTS.CREATE, {
            method: "POST",
            headers: {
                Authorization: authToken(),
            },
            body: formData,
        }, 2);
        return response.json();
    },

}

